export default function resetInsuranceFields(setTouched) {
	const touched = {
		insurance: {
			id: false,
			insuranceProof: false,
			provider: false,
			policyId: false,
			policyHolder: false,
			insuranceCoverage: false,
			coveredIndividuals: false
		}
	}

	setTouched(touched)
}
